import { render, staticRenderFns } from "./manufactor.vue?vue&type=template&id=89a0549c&scoped=true&"
import script from "./manufactor.vue?vue&type=script&lang=js&"
export * from "./manufactor.vue?vue&type=script&lang=js&"
import style0 from "./manufactor.vue?vue&type=style&index=0&id=89a0549c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a0549c",
  null
  
)

export default component.exports